import * as yup from 'yup';

const validationFields = {
  firstName: yup.string(),
  lastName: yup.string(),
  nmls: yup.string().required('validations.loanOfficerRegistration.nmls.required'),
  email: yup
    .string()
    .email('validations.loanOfficerRegistration.email.invalid')
    .required('validations.loanOfficerRegistration.email.required')
    .max(50, 'validations.loanOfficerRegistration.email.maxLength'),
  password: yup
    .string()
    .required('validations.loanOfficerRegistration.password.required')
    .min(8, 'validations.loanOfficerRegistration.password.minLength'),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'validations.loanOfficerRegistration.passwordConfirmation.passwordMatch')
    .required('validations.loanOfficerRegistration.passwordConfirmation.required'),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = {
  firstName: '',
  lastName: '',
  nmls: '',
  email: '',
  password: '',
  passwordConfirmation: '',
};



// WEBPACK FOOTER //
// ./src/forms/loanOfficerRegistrationForm.js